export default __webpack_public_path__ + "static/media/1213.66bc5611.png";